module.exports = __webpack_public_path__ + "img/rzo-logo.521b2345.png";